<template>
  <div class="float-button-group-wrapper">
    <v-fade-transition group>
      <div class="scroll-btn-warpper" v-if="isOverflowHeight" key="scroll-btn-warpper">
        <v-row class="flex-column">
          <v-col v-if="!isNowScrollTop" key="scroll-btn-up">
            <v-btn color="primary" class="up-btn" fab small right @click="$vuetify.goTo(0)">
              <v-icon>mdi-chevron-up</v-icon>
            </v-btn>
          </v-col>
          <v-col v-if="!isNowScrollBottom" key="scroll-btn-down">
            <v-btn color="primary" class="down-btn" fab small right @click="goToBottom">
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-fade-transition>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nowScrollHeight: 0,
      pageHeight: 0,
      viewportHeight: 0,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    setInterval(() => {
      this.handleScroll()
    }, 250)
  },
  computed: {
    isNowScrollTop() {
      return this.nowScrollHeight === 0
    },
    isNowScrollBottom() {
      return this.pageHeight <= this.nowScrollHeight + this.viewportHeight
    },
    isOverflowHeight() {
      return this.pageHeight > this.viewportHeight + 100
    },
  },
  methods: {
    handleScroll() {
      this.viewportHeight = this.$vuetify.breakpoint.height
      this.pageHeight = document.documentElement.offsetHeight
      this.nowScrollHeight = Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop,
      )
    },
    goToBottom() {
      this.$vuetify.goTo(this.pageHeight)
    },
  },
}
</script>
<style lang="scss" scoped>
.float-button-group-wrapper {
  position: fixed;
  bottom: 55px;
  right: 10px;
}
</style>
